// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocaleHelperJs from "../../../../../dist/libs/component-library/src/utils/LocaleHelper.js";
import InputJs from "../../../../../dist/libs/component-library/src/base-components/input/Input.js";
import ModalJs from "../../../../../dist/libs/component-library/src/base-components/modal/Modal.js";
import ButtonJs from "../../../../../dist/libs/component-library/src/base-components/button/Button.js";
import CheckboxJs from "../../../../../dist/libs/component-library/src/base-components/checkbox/Checkbox.js";
import OtpInputJs from "../../../../../dist/libs/component-library/src/base-components/otp-input/OtpInput.js";
import TextInputJs from "../../../../../dist/libs/component-library/src/base-components/text-input/TextInput.js";
import RadioGroupJs from "../../../../../dist/libs/component-library/src/base-components/radio-group/RadioGroup.js";
import IndexJs from "../../../../../dist/libs/component-library/src/composite-components/address-summary/index.js";
import IndexJs$1 from "../../../../../dist/libs/component-library/src/feature-components/vehicle-fare-card/index.js";

var make = ButtonJs;

var Button = {
  make: make
};

var make$1 = InputJs;

var Input = {
  make: make$1
};

var make$2 = CheckboxJs;

var Checkbox = {
  make: make$2
};

var make$3 = TextInputJs;

var TextInput = {
  make: make$3
};

var make$4 = ModalJs;

var Modal = {
  make: make$4
};

var make$5 = RadioGroupJs;

var Radio = {
  make: make$5
};

var make$6 = OtpInputJs;

var OtpInput = {
  make: make$6
};

var make$7 = IndexJs;

var AddressSummary = {
  make: make$7
};

var make$8 = IndexJs$1;

var VehicleFareCard = {
  make: make$8
};

function getLocaleHeaders(prim) {
  return LocaleHelperJs.getLocaleHeaders();
}

var LocaleHelper = {
  getLocaleHeaders: getLocaleHeaders
};

export {
  Button ,
  Input ,
  Checkbox ,
  TextInput ,
  Modal ,
  Radio ,
  OtpInput ,
  AddressSummary ,
  VehicleFareCard ,
  LocaleHelper ,
}
/* make Not a pure module */
